(function() {
    'use strict';

    function blockKeys(e) {
        const blocked = [9, 13, 32, 37, 38, 39, 40];
        if (blocked.includes(e.keyCode)) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    function blockScroll(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }

    function lockUI() {
        if (document.getElementById('kb-ui-lock')) return;

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        window.addEventListener('wheel', blockScroll, { passive: false, capture: true });
        window.addEventListener('touchmove', blockScroll, { passive: false, capture: true });
        window.addEventListener('keydown', blockKeys, true);

        const overlay = document.createElement('div');
        overlay.id = 'kb-ui-lock';
        overlay.style.cssText = `
            position: fixed;
            top: 0; left: 0;
            width: 100%; height: 100%;
            z-index: 2147483646;
            cursor: wait;
            pointer-events: all;
        `;
        document.body.appendChild(overlay);
    }

    function unlockUI() {
        const overlay = document.getElementById('kb-ui-lock');
        if (!overlay) return;

        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';

        window.removeEventListener('wheel', blockScroll, { capture: true });
        window.removeEventListener('touchmove', blockScroll, { capture: true });
        window.removeEventListener('keydown', blockKeys, true);

        overlay.remove();
    }

    const observer = new MutationObserver(() => {
        const pplrOverlay = document.querySelector('.poverlay-bg.addtocartbg');
        const pplrCanvas  = document.querySelector('.pplrabs');

        const active =
            (pplrOverlay && pplrOverlay.offsetParent !== null) ||
            (pplrCanvas  && pplrCanvas.offsetParent  !== null);

        active ? lockUI() : unlockUI();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
    });

})();